import { memo } from 'react';

import { NoSearchResults } from '~/components/NoSearchResults/NoSearchResults';
import { NoSearchResultsInfo } from '~/components/NoSearchResults/shared/NoSearchResultsInfo';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const AllContentNoSearchResults = memo(() => {
  const { currentWorkspace } = useCurrentWorkspace();

  return (
    <NoSearchResults location={currentWorkspace?.name}>
      <NoSearchResultsInfo>Check for typos or filters, or try a different search query.</NoSearchResultsInfo>
    </NoSearchResults>
  );
});

AllContentNoSearchResults.displayName = 'AllContentNoSearchResults';
